// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3966":"65891670","6236":"86126b7f","7585":"f14602f8"}[chunkId] + ".chunk.css";
};